// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { Headline } from "#/components/headline/Headline";
import { Api } from "#/api";
import { CookieSettings } from "@mgs/ci2019-common/src/components/shared/cookie/cookie_settings/CookieSettings";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    CookieSettings,
  },
})
export class MatomoOptOutModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }
}
